<template>
  <div>
    <div class="boardManage--search">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="add"
        v-if="type === 1 ? $auth('data-board-customer::addMenu') : true"
      >
        {{ $t('dashboard-bi::board-management::新增菜单') }}
      </el-button>
    </div>
    <el-card style="height:582px;">
      <z-table
        :columns="columns"
        :data="tableData"
        row-key="folderID"
        :tree-props="{ children: 'children' }"
        :pagination="false"
        :max-height="550"
      >
        <template #folderName="{row}">
          <i class="iconfont" :class="iconMapping(row.icon)" style="margin-right:8px"></i>
          <span>{{ row.folderName }}</span>
        </template>
        <template #position="{row}">
          <span>{{ row.position }}</span>
        </template>
        <template #parentId="{row}">
          <span>
            {{ row.parentId ? $t('dashboard-bi::board-management::菜单') : $t('dashboard-bi::board-management::目录') }}
          </span>
        </template>
        <template #openType="{row}">
          {{ $dataCheck(menuType[row.openType], '-') }}
        </template>
        <template #openTarget="{row}">
          {{
            row.openTarget
              ? row.openTarget === 1
                ? $t('dashboard-bi::board-management::页签')
                : $t('dashboard-bi::board-management::新窗口')
              : '-'
          }}
        </template>
        <template #isHide="{row}">
          <el-switch :value="!row.isHide" @change="checkShowOrHideMenu(row)"></el-switch>
        </template>
        <template #operate="{ row }">
          <template>
            <el-button type="text" @click="edit(row)" v-if="type === 1 ? $auth('data-board-customer::editMenu') : true">
              {{ $t('dashboard-bi::board-management::编辑') }}
            </el-button>
            <el-button
              type="text"
              @click="toAuth(row)"
              v-if="type === 1 && $auth('data-board-customer::toSetting') && row.boardID"
            >
              {{ $t('dashboard-bi::board-management::设置权限') }}
            </el-button>
            <el-button
              type="text"
              v-if="
                !(row.children && row.children.length) &&
                  (type === 1 ? $auth('data-board-customer::deleteMenu') && !row.sourceId : true)
              "
              style="color:#E62C11"
              @click="deleteData(row)"
            >
              {{ $t('system::function::delete') }}
            </el-button>
          </template>
        </template>
      </z-table>
    </el-card>
    <AddOrUpdate v-model="visible" :editRow="editRow" :routerType="type" @refresh="getList"></AddOrUpdate>
    <TransferDialog v-model="showRole" :editRow="editRow" @success="getList"></TransferDialog>
  </div>
</template>

<script>
import { getMenuList, removeMenu, showOrHideMenu } from '@/server/dashboard'
import { columns } from './config'
import AddOrUpdate from './compoents/addOrUpdate.vue'
import TransferDialog from './transfer.vue'
import { iconList, iconMapping } from '@/views/dashboard/board-management/compoents/icon'

export default {
  components: { AddOrUpdate, TransferDialog },
  data() {
    return {
      type: this.$route.name === 'board-center-setting' ? 1 : 2,
      menuType: {
        1: this.$t('dashboard-bi::board-management::第三方链接'),
        2: this.$t('dashboard-bi::board-management::平台看板'),
        3: this.$t('dashboard-bi::board-management::空白看板')
      },
      tableData: [],
      defaultData: [],
      keywords: '',
      editTitle: '',
      visible: false,
      editRow: {
        type: 'add',
        row: {}
      },
      showRole: false,
      columns: columns
    }
  },
  computed: {
    isOwnMerchant() {
      return this.$store.getters.getIsOwnMerchant
    }
  },
  activated() {
    this.getList()
  },
  methods: {
    iconMapping,
    async getList() {
      const res = await getMenuList({ type: this.type, pageNum: 1, pageSize: 10000 })
      if (res.status !== 200) {
        return
      }
      const data = res.result
      if (data.code === this.$code) {
        this.tableData = data.data.items
      }
    },
    add() {
      this.visible = true
      this.editRow = {
        type: 'add'
      }
    },
    edit(row) {
      this.visible = true
      this.editRow = {
        type: 'edit',
        row: { ...row }
      }
    },
    toAuth(row) {
      this.showRole = true
      this.editRow = { ...row }
    },
    checkShowOrHideMenu(row) {
      if (!row.sourceId && !row.isHide) {
        this.$confirm(this.$t('dashboard-bi::board-management::hide_tips'), this.$t('system::rbac::auth_tips'), {
          confirmButtonText: this.$t('dashboard-bi::board-management::确认不可见'),
          cancelButtonText: this.$t('system::common::btn::cancel'),
          type: 'warning'
        }).then(() => {
          this.showOrHideMenu(row)
        })
      } else {
        this.showOrHideMenu(row)
      }
    },
    async showOrHideMenu(row) {
      const res = await showOrHideMenu({ folderID: row.folderID, isHide: row.isHide ? 0 : 1, sourceId: row.sourceId })
      if (res.status !== 200) {
        return
      }
      const data = res.result
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::control_success'))
        this.getList()
        this.$store.dispatch('getBoardList', row)
      }
    },
    deleteData(row) {
      this.$confirm(
        this.$t('dashboard-bi::board-management::delete-tips'),
        this.$t('dashboard-bi::board-management::删除确认'),
        {
          type: 'warning'
        }
      ).then(async () => {
        const res = await removeMenu(row.folderID)
        const data = res.result
        if (data.code === this.$code) {
          this.$message.success(this.$t('system::tip::delete_success'))
          this.getList()
          this.$store.dispatch('getBoardList', row)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.boardManage--search {
  margin-bottom: 16px;
}
</style>
